import SchoolApi from './SchoolApi';
export default SchoolApi;
